import React, { Component } from "react";
import { connect } from "dva";

import NormTable from "./NormTable";
import NormGroup from "./NormGroup";
// import NormGroup from '../../../components/NormGroup'
import NormDetail from "./NormDetail";
import NormEmpty from "./NormEmpty";
import styles from "./index.less";

@connect(({ norm }) => ({
  selectedRowKeys: norm.selectedRowKeys
}))
class NormView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // componentWillUnmount(){
  //   const {dispatch} = this.props
  //   dispatch({
  //     type:'norm/reset'
  //   })
  // }

  renderContent = () => {
    const { record, renderRoot } = this.props;
    if (record.type === 0) {
      return <NormTable record={record} renderRoot={renderRoot} />;
    }
    if (record.type === 1) {
      return <NormGroup record={record} renderRoot={renderRoot} />;
    }
    if (record.type === 2) {
      return <NormDetail record={record} renderRoot={renderRoot} />;
    }
    return <NormEmpty />;
  };

  /**
   * 定义 type 0指标 1指标分组 2指标详情 之后视后端字段定义修改
   */
  render() {
    return (
      <div className={styles.normView}>
        {this.renderContent()}
      </div>
    );
  }
}

export default NormView;
